window.eventsAddedToProductButton = false;

if(!customElements.get('swym-wishlist-product-button')){
    class SwymWishlistProductButton extends HTMLElement{
        constructor(){
            super();
            this._initializeSwymCallBacks();
        }

        _initializeSwymCallBacks(){
          document.addEventListener('swym:default-list-executed', this._init.bind(this));
        }

        _init(){
          if(!window.currentActiveListId) return; 
            this.wishlistButton = this.querySelector('.swym-wishlist-product-button');
            if(!window.eventsAddedToProductButton){
                window.eventsAddedToProductButton = true;
                this.wishlistButton.classList.add('swym-loaded');
                this.wishlistButton.addEventListener('click', this._handleAddToWishlistEvent.bind(this));

                _swat.evtLayer.addEventListener(_swat.JSEvents.variantChanged, (data) => {
                    this.wishlistButton.classList.add('swym-visibility-hidden');
                    window.currentVariantTitle = data.detail.d.variant.title;
                    window.currentVariantId = data.detail.d.variant.id;
                    this.wishlistButton.setAttribute('data-variant-id', window.currentVariantId);
                    setTimeout(this._refreshButtons.bind(this), 200);
                });

                _swat.evtLayer.addEventListener(_swat.JSEvents.removedFromWishlist, this._refreshButtons.bind(this));

                _swat.evtLayer.addEventListener(_swat.JSEvents.addedToWishlist, this._refreshButtons.bind(this));
            }
            setTimeout(this._refreshButtons.bind(this), 200);
        }

        async _refreshButtons(){
            const listProducts = await swymCustomFunctions.fetchListProductsDetails(_swat, window.currentActiveListId);
            this.wishlistButton.classList.remove('swym-visibility-hidden');
            const isAdded = listProducts.some(product => product.epi == window.currentVariantId);
            this.wishlistButton.classList.toggle('swym-added', isAdded);
            this.wishlistButton.classList.remove('disabled');
            this.wishlistButton.dataset.action = isAdded ? 'remove' : 'add';
            // isAdded ? this.wishlistButton.setAttribute('data-action', 'remove') : this.wishlistButton.setAttribute('data-action', 'add');
            window.listProductsCount = listProducts.length;
            swymCustomFunctions.updateHeaderCounter();
            
            // _swat.fetch(products => {
            //     this.wishlistButton.classList.remove('swym-visibility-hidden');
            //     const isAdded = products.some(product => product.epi == window.currentVariantId);
            //     this.wishlistButton.classList.toggle('swym-added', isAdded);
            //     this.wishlistButton.classList.remove('disabled');
            //     this.wishlistButton.dataset.action = isAdded ? 'remove' : 'add';
            //     // isAdded ? this.wishlistButton.setAttribute('data-action', 'remove') : this.wishlistButton.setAttribute('data-action', 'add');
            //     window.listProductsCount = products.length;
            //     swymCustomFunctions.updateHeaderCounter();
            // });
        }

        _handleAddToWishlistEvent(evt){
            evt.preventDefault();
            const variantInWishlist = this.wishlistButton.classList.contains('swym-added');
            let lid = window.currentActiveListId;
            let product = {
                epi: window.currentVariantId,
                empi: this.wishlistButton.getAttribute('data-product-id'),
                du: this.wishlistButton.getAttribute('data-product-url')
            };

            const setWishlistButtonState = (isAdded) => {
                this.wishlistButton.classList.toggle('swym-added', isAdded);
            };

            let onSuccess = item => console.log('Product updated from list - ', item);
            let onError = error => console.error("Error while modifying the Product on the List - ", error);
            let customSuccessHandling = item => {
                setWishlistButtonState(true);
                let productTitle = window.currentProductTitle;
                let variantTitle = window.currentVariantTitle.toLowerCase() == 'default title' ? '' : ` - ${window.currentVariantTitle}`;
                let imageURL = window.currentVariantImage;
                const title = `${productTitle}${variantTitle}`;
                const message = _swat.retailerSettings.Strings.AddWishlistAddSuccess.replace(/{{{?variantName}?}}/g,title);
                const html = `
                        <style>
                        .swym-notification-success-inner .swym-image{ display: none !important }
                        #swym-custom-notification-content { display: flex; align-items: center; cursor: pointer }
                        #swym-custom-notification-content #swym-custom-image-container { min-height: 96px; min-width: 96px; max-height: 96px; max-width: 96px; overflow: hidden; background: rgb(var(--color-base-brand-lightest-grey))!important; }
                        #swym-custom-notification-content #swym-custom-image-container #swym-custom-image { width: 100%; object-fit: cover; aspect-ratio: 1 / 1; mix-blend-mode: multiply!important }
                        .swym-notification-success-inner, .swym-notification-success-inner .swym-details-container .swym-details { padding-block: 0 !important; padding-left: 0 !important }
                        #swym-custom-notification-content #swym-custom-title-conatainer { font-family: var(--font-heading-family); padding-inline: 16px 25px; color: #434655; font-size: var(--text-size-xs); font-weight: font-weight: var(--font-weight-normal); letter-spacing: normal !important; line-height: var(--leading-looser) }
                        #swym-custom-notification-content #swym-custom-title-conatainer .swym-emphasis { color: rgb(var(--color-base-dark)); display: block; font-weight: var(--font-weight-medium); text-transform: uppercase; }
                    </style>
                    <div id="swym-custom-notification-content" onclick="_swat.ui.open()">
                        <div id="swym-custom-image-container">
                            <img id="swym-custom-image" src="${imageURL}" alt="wishlisted product image"/>
                        </div>
                        <div id="swym-custom-title-conatainer">${message}</div>
                    </div>
                `;
                _swat.ui.showSuccessNotification({message: html});
            }
            !variantInWishlist ? _swat.addToList(lid, product, customSuccessHandling, onError) : _swat.deleteFromList(lid, product, onSuccess, onError);
        }
    }
    customElements.define('swym-wishlist-product-button', SwymWishlistProductButton);
}